// extracted by mini-css-extract-plugin
export var cancelButton = "_p2-5";
export var content = "_p2-3";
export var createButton = "_p2-6";
export var drawerContainer = "_p2-0";
export var footer = "_p2-2";
export var header = "_p2-1";
export var orderFormColumn = "_p2-4";